import React from 'react';
import Svg from "../Svg";
import PropTypes from "prop-types";

const IconServiceFood = () => (
	<div className="icon-service icon-service-food">
		<Svg width={14} height={14}>
			<g strokeWidth="1" transform="translate(1.000000, 1.000000)" fill="#FFFFFF">
				<path
					d="M6.22222222,5.05575556 L4.66666667,5.05575556 L4.66666667,0.0002 L3.11111111,0.0002 L3.11111111,5.05575556 L1.55555556,5.05575556 L1.55555556,0.0002 L0,0.0002 L0,5.05575556 C0,6.65186667 1.39222222,7.94464444 3.11111111,7.94464444 L3.11111111,14.4446444 L4.66666667,14.4446444 L4.66666667,7.94464444 C6.38555556,7.94464444 7.77777778,6.65186667 7.77777778,5.05575556 L7.77777778,0.0002 L6.22222222,0.0002 L6.22222222,5.05575556 Z M10.1111111,2.88908889 L10.1111111,8.66686667 L12.4444444,8.66686667 L12.4444444,14.4446444 L14,14.4446444 L14,0.0002 C11.8533333,0.0002 10.1111111,1.61797778 10.1111111,2.88908889 L10.1111111,2.88908889 Z"/>
			</g>
		</Svg>
	</div>
);

IconServiceFood.defaultProps = {
	fill: '#ffffff'
};

IconServiceFood.propTypes = {
	fill: PropTypes.string
};

export default IconServiceFood;
